// Only format visible text. Keep API data, identifiers and submitted values unchanged.
export function displayGameName(value) {
  return typeof value === 'string'
    ? value.replaceAll('大吃小', '十门').replaceAll('牌九', '五门')
    : value
}

// Use with Vue computed() for editors: opening or saving an unchanged form
// must not replace the stored name with its display alias.
export function displayNameField(target, key) {
  return {
    get: () => displayGameName(target[key]),
    set: (value) => {
      if (value !== displayGameName(target[key])) target[key] = value
    },
  }
}
